var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.166,
    height: 13.921,
    viewBox: "0 0 15.166 13.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(-766.417 -1283.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M7.257,3.1a2,2,0,0,1,3.486,0l5.58,9.921A2,2,0,0,1,14.58,16H3.42a2,2,0,0,1-1.743-2.981Z",
    transform: "translate(765 1281)",
    fill: "rgba(240,157,24,0.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(-336 1088)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y1: 3.663,
    transform: "translate(1110 200)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(1109 205.927)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    rx: 1,
    ry: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterWarningIcon);
export default __webpack_public_path__ + "static/media/toaster-warning-icon.79d124a6828914920eefd8475418975c.svg";
export { ForwardRef as ReactComponent };